import { AxisSide, AxisSpec, PanelType, StreamEntry, TimeAxisPanelSpec } from "../ChartSpec";
import type { ResolvedStream } from "./resolve-streams";
import { stableStreamColor } from "./stable-stream-color";

export function buildTwoAxisPanel(
    leftStreams: ResolvedStream[],
    rightStreams: ResolvedStream[],
): TimeAxisPanelSpec | null {
    if (leftStreams.length === 0 && rightStreams.length === 0) return null;

    const axes: AxisSpec[] = [];
    const streams: StreamEntry[] = [];

    if (leftStreams.length > 0) {
        const axisId = leftStreams[0].unitCategory;
        axes.push({ id: axisId, unitCategory: axisId, side: AxisSide.Left });
        streams.push(...leftStreams.map((s) => toStreamEntry(s, axisId)));
    }

    if (rightStreams.length > 0) {
        const axisId = rightStreams[0].unitCategory;
        axes.push({ id: axisId, unitCategory: axisId, side: AxisSide.Right });
        streams.push(...rightStreams.map((s) => toStreamEntry(s, axisId)));
    }

    return {
        id: `two-axis-panel-${leftStreams[0]?.unitCategory}-${rightStreams[0]?.unitCategory}`,
        type: PanelType.TimeAxis,
        axes,
        streams,
    };
}

export function buildCategoryPanel(unitCategory: string, resolvedStreams: ResolvedStream[]): TimeAxisPanelSpec {
    const axisId = unitCategory;
    return {
        id: `category-panel-${unitCategory}`,
        type: PanelType.TimeAxis,
        axes: [{ id: axisId, unitCategory, side: AxisSide.Left }],
        streams: resolvedStreams.map((s) => toStreamEntry(s, axisId)),
    };
}

function toStreamEntry(stream: ResolvedStream, axisId: string): StreamEntry {
    return {
        streamId: stream.id,
        color: stableStreamColor(stream.id),
        name: stream.name,
        axisId,
    };
}
